module.exports = __webpack_public_path__ + "static/media/skf.1d5f4914.png";